const LABEL = {
  geplant: "Geplant",
  unterwegs: "Unterwegs",
  abgeschlossen: "Abgeschlossen",
  storniert: "Storniert",
};

export default function StatusBadge({ status, className = "" }) {
  const key = (status || "geplant").toLowerCase();
  const cls =
    key === "unterwegs"
      ? "badge-unterwegs"
      : key === "abgeschlossen"
      ? "badge-abgeschlossen"
      : key === "storniert"
      ? "badge-storniert"
      : "badge-geplant";
  return (
    <span
      data-testid="trip-status-badge"
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold tracking-wide ${cls} ${className}`}
    >
      {LABEL[key] || status}
    </span>
  );
}
